import { colors } from './colors';

export function init(opt) {
  if (opt === undefined) opt = {};
  if (opt.count === undefined) opt.count = 300;
  if (opt.ratio === undefined) opt.ratio = 0.61;
  if (opt.radius === undefined) opt.radius = 0.005;
  if (opt.retina === undefined) opt.retina = (typeof window === 'object') ? window.devicePixelRatio : 1;
  if (opt.fps === undefined) opt.fps = 25; // frames per seconds
  if (opt.spf0 === undefined) opt.spf0 = 2; // simulation steps per frame
  if (opt.spf === undefined) opt.spf = opt.spf0; // simulation steps per frame
  if (opt.pointSpeed === undefined) opt.pointSpeed = 0.1; // initial speed of points
  if (opt.movingRatio === undefined) opt.movingRatio = 0.5; // number of mobile points
  if (opt.sickDur === undefined) opt.sickDur = 300; // duration of sickness
  if (opt.chartWidth === undefined) opt.chartWidth = 200; // duration of sickness
  if (opt.chartHeight === undefined) opt.chartHeight = 60; // duration of sickness
  if (opt.maxSteps === undefined) opt.maxSteps = 1200; // simulation steps per chart column

  opt.stepsPerCol = Math.round(opt.maxSteps/(opt.chartWidth*opt.retina));

  const parent = document.getElementById(opt.id);
  parent.style['overflow-x'] = 'hidden';
  parent.style['line-height'] = 0;

  const nodeChart = parent.querySelector('canvas.mini-chart');
  nodeChart.width  = opt.chartWidth *opt.retina;
  nodeChart.height = opt.chartHeight*opt.retina;
  nodeChart.style.width  = `${opt.chartWidth}px`;
  nodeChart.style.height = `${opt.chartHeight}px`;
  nodeChart.style.position = 'absolute';
  nodeChart.style.left = 0;
  const ctxChart = nodeChart.getContext('2d');

  const buttonReset = parent.querySelector('.button-reset');
  buttonReset.addEventListener('click', reset);
  buttonReset.addEventListener('touchstart', reset);
  const buttonPause = parent.querySelector('.button-pause');
  buttonPause.addEventListener('click', stop);
  buttonPause.addEventListener('touchstart', stop);
  const buttonPlay = parent.querySelector('.button-play');
  buttonPlay.addEventListener('click', play);
  buttonPlay.addEventListener('touchstart', play);
  const buttonFast = parent.querySelector('.button-fast');
  buttonFast.addEventListener('click', playFast);
  buttonFast.addEventListener('touchstart', playFast);
  const nodeCanvas = parent.querySelector('canvas.ball-pit');
  const ctxMain = nodeCanvas.getContext('2d');

  const healthyValue = parent.querySelector('.healthy-value');
  const infectedValue = parent.querySelector('.infected-value');
  const curedValue = parent.querySelector('.cured-value');

  const px = new Array(opt.count);
  const py = new Array(opt.count);
  const vx = new Array(opt.count);
  const vy = new Array(opt.count);
  const mass = new Array(opt.count);
  const status = new Array(opt.count);
  let width;
  let height;
  let step;
  let simulationInterval;
  let chartSum0;
  let chartSum1;
  let chartSum2;

  const gridSize = opt.radius*2;
  const gridWidth = Math.floor(1/gridSize);
  const indexDelta = [-gridWidth-1, -gridWidth, -gridWidth+1, -1, 0, 1, gridWidth-1, gridWidth, gridWidth+1];
  const hashGrid = new Uint16Array(gridWidth*Math.ceil(gridWidth*opt.ratio));
  const hashList = new Uint16Array(opt.count);

  const observer = new IntersectionObserver(observable => {
    if (observable[0].isIntersecting) {
      start();
      observer.unobserve(observable[0].target);
    }
  }, { threshold: 0.6 });

  observer.observe(parent);

  init();
  resize();

  function reset(e) {
    if (e && e.preventDefault) e.preventDefault();
    init();
    play();
  }
  function play(e) {
    if (e && e.preventDefault) e.preventDefault();
    opt.spf = opt.spf0*1;
    start();
  }
  function playFast(e) {
    if (e && e.preventDefault) e.preventDefault();
    opt.spf = opt.spf0*10;
    start();
  }

  function init() {
    chartSum0 = opt.count-1;
    chartSum1 = 1;
    chartSum2 = 0;
    step = 0;

    for (let i = 0; i < opt.count; i++) {
      px[i] = Math.random();
      py[i] = Math.random()*opt.ratio;
      mass[i] = (i < opt.movingRatio*opt.count) ? 1 : 1000;
      vx[i] = opt.pointSpeed/mass[i]*(Math.random()-0.5);
      vy[i] = opt.pointSpeed/mass[i]*(Math.random()-0.5);

      status[i] = 0;
    }
    status[0] = 1;
    px[0] = 0.5;
    py[0] = 0.5*opt.ratio;

    ctxChart.clearRect(0,0,nodeChart.width,nodeChart.height);

    drawChartCol();
  }

  function start() {
    stop();
    simulationInterval = setInterval(simulate, 1000/opt.fps);
  }

  function stop(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (!simulationInterval) return;
    clearInterval(simulationInterval);
    simulationInterval = false;
  }

  function drawChartCol() {
    const h  = opt.chartHeight*opt.retina;
    const totalSum = chartSum0+chartSum1+chartSum2;
    const y1 = h*(chartSum0          )/totalSum;
    const y2 = h*(chartSum0+chartSum2)/totalSum;
    const y3 = h;

    healthyValue.innerText = (chartSum0/totalSum*100)
      .toFixed(1).replace('.',',') + ' %';
    infectedValue.innerText = (chartSum1/totalSum*100)
      .toFixed(1).replace('.',',') + ' %';
    curedValue.innerText = (chartSum2/totalSum*100)
      .toFixed(1).replace('.',',') + ' %';

    chartSum0 = 0;
    chartSum1 = 0;
    chartSum2 = 0;

    const x0 = Math.floor(step/opt.stepsPerCol);
    if (x0 > opt.chartWidth*opt.retina) return stop();

    ctxChart.fillStyle = colors.sick;
    ctxChart.fillRect(x0,0,1,y3);

    ctxChart.fillStyle = colors.cured;
    ctxChart.fillRect(x0,0,1,y2);

    ctxChart.fillStyle = colors.healthyArea;
    ctxChart.fillRect(x0,0,1,y1);
  }

  function simulate() {
    if (step >= opt.maxSteps) return stop();

    const r = opt.radius;

    const w = 1;
    const h = opt.ratio;

    for (let s = 0; s < opt.spf; s++) {

      hashGrid.fill(0);
      hashList.fill(0);

      for (let i = 0; i < opt.count; i++) {
        if (status[i] > 0) status[i]++;

        px[i] += vx[i]/opt.fps;
        py[i] += vy[i]/opt.fps;

        // reflect from walls
        if (px[i] <   r) { px[i] = 2*(  r)-px[i]; vx[i] *= -1; }
        if (px[i] > w-r) { px[i] = 2*(w-r)-px[i]; vx[i] *= -1; }
        if (py[i] <   r) { py[i] = 2*(  r)-py[i]; vy[i] *= -1; }
        if (py[i] > h-r) { py[i] = 2*(h-r)-py[i]; vy[i] *= -1; }

        const x0 = Math.round(px[i]/gridSize);
        const y0 = Math.round(py[i]/gridSize);
        const index = x0 + y0*gridWidth;

        indexDelta.forEach(d => {
          if (!hashGrid[index+d]) return;
          let i2 = hashGrid[index+d]-1;
          do {
            checkCollision(i,i2);
            i2 = hashList[i2]-1;
          } while (i2 >= 0);
        });

        if (!hashGrid[index]) {
          hashGrid[index] = i+1;
        } else {
          hashList[i] = hashGrid[index];
          hashGrid[index] = i+1;
        }
      }

      status.forEach(s => {
        if (s === 0) return chartSum0++;
        if (s > opt.sickDur) return chartSum2++;
        chartSum1++;
      });

      if (step % opt.stepsPerCol === 0) drawChartCol();

      step++;
    }

    draw();

    function checkCollision(i1, i2) {
      const dx = px[i1]-px[i2];
      const dy = py[i1]-py[i2];
      const d = Math.sqrt(dx*dx + dy*dy);
      if (d > 2*r) return;
      const fix = 4*r/d-2;
      px[i1] = px[i1] + dx*fix;
      px[i2] = px[i2] - dx*fix;
      py[i1] = py[i1] + dy*fix;
      py[i2] = py[i2] - dy*fix;

      const dvx = vx[i1]-vx[i2];
      const dvy = vy[i1]-vy[i2];
      const dvl = (dvx*dx + dvy*dy)/(d*d);
      vx[i1] -= dvl*dx*2*mass[i2]/(mass[i1]+mass[i2]);
      vy[i1] -= dvl*dy*2*mass[i2]/(mass[i1]+mass[i2]);
      vx[i2] += dvl*dx*2*mass[i1]/(mass[i1]+mass[i2]);
      vy[i2] += dvl*dy*2*mass[i1]/(mass[i1]+mass[i2]);

      if (status[i1] > 0) { // 1 was infected
        if (status[i1] > opt.sickDur) return; // 1 is cured
        if (status[i2] === 0) status[i2] = 1; // 1 infects 2
      } else { // 1 is healthy
        if (status[i2] === 0) return; // both are healthy
        if (status[i2] > opt.sickDur) return; // 2 is cured
        status[i1] = 1;
      }
    }
  }

  function draw() {
    ctxMain.clearRect(0, 0, nodeCanvas.width, nodeCanvas.height);
    const zoom = nodeCanvas.width;

    for (let i = 0; i < opt.count; i++) {
      ctxMain.beginPath();
      if (status[i] === 0) {
        ctxMain.fillStyle = colors.healthy;
      } else if (status[i] > opt.sickDur) {
        ctxMain.fillStyle = colors.cured;
      } else {
        ctxMain.fillStyle = colors.sick;
      }
      ctxMain.arc(px[i]*zoom, py[i]*zoom, opt.radius*zoom, 0, 2*Math.PI);
      ctxMain.fill();
    }
  }

  function resize() {
    width = parent.offsetWidth;
    height = Math.round(width*opt.ratio);

    nodeCanvas.width = width*opt.retina;
    nodeCanvas.height = height*opt.retina;
    nodeCanvas.style.width = `${width}px`;
    nodeCanvas.style.height = `${height}px`;

    draw();
  }

  return { resize };
}
